// StyledButton.js
import styled from "styled-components";
import { Button } from "antd";

// Styled-component extending Ant Design's Button
const StyledButton = styled(Button)`
  background-color: #e69500 !important;
  color: white !important;
  border: none !important;
  font-weight: bold;
  font-size: 16px;
`;

export default StyledButton;
